module.exports = __webpack_public_path__ + "static/media/frankHendrickx.3b108446.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/frankHendrickx.jpg
// module id = 1673
// module chunks = 1